import type { Primitive } from '@global/types/Primitive'

export const copyToClipboard = (text: Primitive | URL): void => {
  navigator.clipboard.writeText(text?.toString() || '')
}
